import { Navigate } from "@solidjs/router";
import { contentFitnessDimensionForKey } from "contracts/report/content-fitness/lookups";
import { MetricDetail } from "../metric-detail/MetricDetail";

export function ScanMetricRoute(props: {
  websiteId: string;
  metricKey: string;
}) {
  const dimension = contentFitnessDimensionForKey(props.metricKey);
  return dimension ? (
    <Navigate
      href={`/w/${props.websiteId}/scan/content-fitness/${dimension.key}`}
    />
  ) : (
    <MetricDetail websiteId={props.websiteId} metricKey={props.metricKey} />
  );
}
